import classNames from 'classnames';
import React from 'react';

export interface IProps {
  className?: string;
  value?: string;
}

const ClickFieldError: React.FC<IProps> = ({ className, value }) => {
  const computedClassName = React.useMemo<string>(() => {
    return classNames('mt-1 pb-2 text-xs font-medium text-rose-500', className);
  }, [className]);

  const error = React.useMemo<string | undefined>(() => {
    return value?.split(',')?.at(-1);
  }, [value]);

  return (
    <div className={computedClassName}>
      <p>{error}</p>
    </div>
  );
};

export default ClickFieldError;
